import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {EvkExpedienteModel} from '../../../../../../expediente/models/evk-expediente.model';
import {EvkExpedienteConfigModel} from '../../../../../../expediente/models/evk-expediente-config.model';
import {CatalogosService} from '../../../../../../expediente/services/catalogos.service';
import {DatosSeccionWizardEventsService} from '../../../../../services/datos-seccion-wizard-events.service';
import {ConficuracionDocumentosModel, FiltroPaginadorDocumentosModel, LlaveNegocioModel} from '@evomatik/evk-content';
import {EvkSecurityControlDataService} from '@evomatik/evk-seguridad';
import {PasoWizard} from '../../../../../interface/wizard-informacion.types';
import {EstadoExpedienteModel} from "../../../../../../expediente/models/estado-expediente.model";
import { KeycloakService } from 'keycloak-angular';
import { ButtonControlService } from '../../../../../services/button-control.service';

@Component({
    selector: 'lib-documentos',
    templateUrl: './documentos.component.html',
    styleUrls: ['./documentos.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class DocumentosComponent implements OnInit, OnDestroy {
    @Output() adjuntandoDocumentos: EventEmitter<boolean> = new EventEmitter();
    @Input()
    expediente: EvkExpedienteModel;
    @Input()
    expedienteConfig: EvkExpedienteConfigModel;
    @Input()
    readOnly: boolean = false;
    configuracionDocumentos: ConficuracionDocumentosModel;
    tipoExpediente: string;
    @Input()
    config: PasoWizard;
    @Input()
    descargaZipByFolio: boolean;
    @Input()
    skipByVersion: boolean;
    paso: PasoWizard;
    error: boolean = false;
    estadoExpediente: EstadoExpedienteModel;
    @Output() readonly resultObject: EventEmitter<Object> = new EventEmitter<Object>();
    constructor(
        public catalogoService: CatalogosService,
        public datosSeccionWizard: DatosSeccionWizardEventsService,
        private evkSecurity: EvkSecurityControlDataService,
        private keycloakService: KeycloakService,
        private buttonControlService: ButtonControlService,
    ) {}

    ngOnDestroy(): void {
    }

    ngOnInit(): void {
        // this.expediente = this.data?.paso?.inData?.expediente;
        if(this.expediente && this.expediente?.configuracionExpediente){
            this.tipoExpediente = this.expediente?.configuracionExpediente?.id;
            this.estadoExpediente = this.expediente?.estadoActivo?.estado;
            console.log("estadoExpediente____")
            console.log(this.estadoExpediente)
            this.configurarDocumentos();
        } else {
            this.error = true
        }
    }

    getRelativePath(): string {
        const folioNegocio = this.expediente?.folioProvisional?.split("/")
        return `${folioNegocio.join("-")}${this.config && this.config.discriminador ? "/" + this.config.discriminador : ""}`;
    }

    creaLlaveNegocio(key: string, valor: any): LlaveNegocioModel {
        const llave = new LlaveNegocioModel();
        llave.llave = key;
        llave.valor = valor;
        return llave;
    }

    validateViewRol(viewRol) {
        if (viewRol != undefined && viewRol != '') {
            const roles = viewRol.split(',');
            return roles.some(rol => this.keycloakService.isUserInRole(rol));
        }
        return false;
    }
    configurarDocumentos(){
        console.log("configurarDocumentos")
        this.configuracionDocumentos = new ConficuracionDocumentosModel();
        this.configuracionDocumentos.tiposDocumento = [];
        this.configuracionDocumentos.tipoDocumentoIdentificador = this.config && this.config.discriminador ? this.config.discriminador : "TIPO-DOCUMENTO";
        //TODO obtener documentos default desde config
        this.configuracionDocumentos.tipoDocumentoDefault = ".pdf";
        this.configuracionDocumentos.tipoDocumentoMultipleDefault = ".pdf";

        this.configuracionDocumentos.titleContainer = this.config && this.config.descripcion ? this.config.descripcion : "Adjuntar Documento";
        this.configuracionDocumentos.titleContainerMultiple = this.config && this.config.descripcion ? this.config.descripcion : "Adjuntar Documento";

        this.configuracionDocumentos.title = this.config && this.config.descripcion ? this.config.descripcion : "Adjuntar documentos";
        this.configuracionDocumentos.titleMultiple = this.config && this.config.descripcion ? this.config.descripcion : "Ajuntar documentos";

        this.configuracionDocumentos.folioNegocio = this.expediente.folioProvisional;

        if (this.evkSecurity.getUsuarioInfo().cargo != undefined && this.evkSecurity.getUsuarioInfo() != undefined) {
            this.configuracionDocumentos.puesto = this.evkSecurity.getUsuarioInfo().cargo;
        } else {
            this.configuracionDocumentos.puesto = '';
        }
        this.configuracionDocumentos.usuario = this.evkSecurity.getUsuarioInfo().username;
        this.configuracionDocumentos.nombre = this.evkSecurity.getUsuarioInfo().nombreCompleto;
        this.configuracionDocumentos.relativePath = this.getRelativePath();
        if (this.estadoExpediente && this.estadoExpediente?.nombre?.toLowerCase() == 'finalizado') {
            this.configuracionDocumentos.canAdd = false;
        } else {
            this.configuracionDocumentos.canAdd = true;
        }
        if(this.configuracionDocumentos.tipoDocumentoIdentificador === "DESCARGA-CERTIFICADO"){
            this.configuracionDocumentos.canAdd = false;
            this.configuracionDocumentos.filtro.tipo = ".cer";
        }
        this.configuracionDocumentos.canEdit = this.validateViewRol("CIUDADANO,FUNCIONARIO") && this.estadoExpediente?.nombre?.toLowerCase() !== 'finalizado';
        this.configuracionDocumentos.canDelete = this.validateViewRol("FUNCIONARIO") && this.estadoExpediente?.nombre?.toLowerCase() !== 'finalizado';
        this.configuracionDocumentos.canView = true;
        this.configuracionDocumentos.llavesNegocio = [];

        const idProyecto = this.expediente.id;
        this.configuracionDocumentos.llavesNegocio.push(this.creaLlaveNegocio('idExpediente', idProyecto));

        this.configuracionDocumentos.filtro = new FiltroPaginadorDocumentosModel();
        this.configuracionDocumentos.showDescargaZip = false;
        this.configuracionDocumentos.showStatus = true;
        this.configuracionDocumentos.filtro.llavesNegocio = JSON.stringify(
            [
                this.creaLlaveNegocio('idExpediente', idProyecto)
            ]);
        // this.configuracionDocumentos.metadatosNegocio = [{ llave: 'PRUEBA_METADATA', valor: 'XYZ_123' }];
        this.configuracionDocumentos.filtro.folioNegocio = this.expediente.folioProvisional;
        //TODO estos ocultan botones de adjuntar con catalogo o normal
        this.configuracionDocumentos.filtro.allAdjunto = false;
        this.configuracionDocumentos.filtro.allGenerado = false;
        this.configuracionDocumentos.filtro.relativePath = this.getRelativePath();
        this.configuracionDocumentos.filtro.usuario = this.evkSecurity.getUsuarioInfo().username;
        // this.configuracionDocumentos.filtro.metadatosNegocio = JSON.stringify([{ llave: 'PRUEBA_METADATA', valor: 'XYZ_123' }]);
        if(this.descargaZipByFolio){
            this.configuracionDocumentos.showDescargaZip = true;
            this.configuracionDocumentos.descargaZipByFolio = true;
        }
        if(this.skipByVersion){
            this.configuracionDocumentos.skipByVersion = true;
        }
        this.catalogoService.getByDiscriminator(this.configuracionDocumentos.tipoDocumentoIdentificador)
        .subscribe(respuesta => {
            this.configuracionDocumentos.tiposDocumento = respuesta;
        });
    }

    validAdjuntar(event: boolean) {
        this.adjuntandoDocumentos.emit(!event);
    }
    elementos(event: number) {
        if(event === 0){
            this.buttonControlService.cambiarBotonSiguiente(false);
            if(this.config && this.config.requerido){
                //TODO descomentar si se requiere esta funcionalidad oara wizard expedientes
                this.buttonControlService.cambiarBotonSiguiente(false);
                this.resultObject.next({
                    event: "fromDucuments",
                    valid: false,
                });
            }
        } else {
            if(this.config && this.config?.requerido){
                //TODO descomentar si se requiere esta funcionalidad oara wizard expedientes
                this.buttonControlService.cambiarBotonSiguiente(true);
                this.resultObject.next({
                    event: "fromDucuments",
                    valid: true,
                });
            }
        }
        if (!this.config?.requerido) {
            this.buttonControlService.cambiarBotonSiguiente(true);
        }
    }

}
